export const IS_MAC = typeof window !== "undefined" && /Mac|iPod|iPhone|iPad/.test(window.navigator.userAgent);
export const META_KEY = IS_MAC ? "⌘" : "Ctrl";
